import { bytesToSize } from "./bytes-to-size";

const PERFORMANCE_THRESHOLDS = {
  POLYGONS_LOW: 10000,
  POLYGONS_MEDIUM: 50000,
  FILE_SIZE_LOW: 10 * 1024 * 1024, // 10 MB
  FILE_SIZE_MEDIUM: 50 * 1024 * 1024, // 50 MB
  WARNING_POLYGONS_THRESHOLD: 10000,
  WARNING_FILE_SIZE_THRESHOLD: 10 * 1024 * 1024
};

const getDensityScore = triangles => {
  if (triangles <= PERFORMANCE_THRESHOLDS.POLYGONS_LOW) {
    return "Low";
  }

  if (triangles <= PERFORMANCE_THRESHOLDS.POLYGONS_MEDIUM) {
    return "Medium";
  }

  return "High";
};

const getSizeScore = size => {
  if (size < PERFORMANCE_THRESHOLDS.FILE_SIZE_LOW) {
    return "Low";
  }

  if (size < PERFORMANCE_THRESHOLDS.FILE_SIZE_MEDIUM) {
    return "Medium";
  }

  return "High";
};

export const calculateModelOptimizationInfo = (stats, fileSize) => {
  const triangles = stats?.triangles || 0;
  const sizeInBytes = stats?.totalSize || fileSize || 0;

  const densityScore = getDensityScore(triangles);
  const sizeScore = getSizeScore(sizeInBytes);
  const hasWarnings =
    triangles > PERFORMANCE_THRESHOLDS.WARNING_POLYGONS_THRESHOLD ||
    sizeInBytes >= PERFORMANCE_THRESHOLDS.WARNING_FILE_SIZE_THRESHOLD;

  return {
    triangles,
    size: sizeInBytes,
    densityScore,
    sizeScore,
    hasWarnings,
    readableSize: bytesToSize(sizeInBytes)
  };
};



